import React from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { CLIENTS } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <View style={{ flexDirection: 'row', gap: 12 }}>
        <Link to={`/clients/${entry.id}`}>
          <Text>View/Edit</Text>
        </Link>

        <Link to={`/clients/${entry.id}/events`}>
          <Text>Events</Text>
        </Link>
      </View>
    )
  }
];

const Clients = () => {
  const { data } = useQuery(CLIENTS, { fetchPolicy: 'network-only' } );

  return (
    <View>
      <Title>Clients</Title>

      <Link to="/clients/new">
        <Text>Add Client</Text>
      </Link>

      {data && (
        <DataTable.Simple
          data={data.clients}
          columns={columns}
        />
      )}
    </View>
  );
};

export default Clients;
